import React from "react";
import clsx from "clsx";

export type AppShellProps = {
  children: React.ReactNode;
  className?: string;
};

// Shared outer shell to keep consistent max dimensions/background across embedded and standalone apps
export function AppShell({ children, className }: AppShellProps) {
  return (
    <div
      className={clsx(
        "relative mx-auto h-full max-h-[1024px] w-full max-w-[1366px] bg-white",
        className
      )}
    >
      {children}
    </div>
  );
}
